// Copyright (c) 2015-present, salesforce.com, inc. All rights reserved

import * as types from './actionTypes';

export function changeCurrentPage (payload) {
	return {
		type: types.CURRENT_PAGE_CHANGE,
		payload
	};
}

export function changeToRestoreTokenValidationPage () {
	const payload = {
		tokenValidation: true,
		restoreRequest: false,
		restoreResponse: false
	};

	return ((dispatch) => {
		dispatch(changeCurrentPage(payload));
	});
}

export function changeToRestoreRequestPage () {
	const payload = {
		tokenValidation: false,
		restoreRequest: true,
		restoreResponse: false
	};

	return ((dispatch) => {
		dispatch(changeCurrentPage(payload));
	});
}

export function changeToRestoreResponsePage () {
	const payload = {
		tokenValidation: false,
		restoreRequest: false,
		restoreResponse: true
	};

	return ((dispatch) => {
		dispatch(changeCurrentPage(payload));
	});
}
